export default __webpack_public_path__ + "static/media/blood-sugar.8a68163b.svg";